export default {
  en: {
    paymentmethods: {
      heading: 'Payment Methods',
      add: 'Add Payment Method',
      description: 'To pay for your subscription, you can add additional payment methods here.',
    },
    subscription: {
      heading: 'Subscriptions',
      description: 'Your subscriptions, invoices and purchases will show up here.',
      noSubscriptions: 'No subscriptions found',
      per: 'per',
      since: 'since',
      interval: {
        day: 'day',
        week: 'week',
        month: 'month',
        year: 'year',
      },
    },

    Selected: 'Selected',
    Select: 'Select',
    Expiration: 'Expiration',
  },
  de: {
    paymentmethods: {
      heading: 'Zahlungsmethoden',
      add: 'Zahlungsmethode hinzufügen',
      description: 'Um Ihr Abonnement zu bezahlen, können Sie hier zusätzliche Zahlungsmethoden hinzufügen.',
    },
    subscription: {
      heading: 'Abonnements',
      description: 'Ihre Abonnements, Rechnungen und Käufe werden hier angezeigt.',
      noSubscriptions: 'Keine Abonnements gefunden',
      per: 'pro',
      since: 'seit',
      interval: {
        day: 'Tag',
        week: 'Woche',
        month: 'Monat',
        year: 'Jahr',
      },
    },

    Selected: 'Ausgewählt',
    Select: 'Auswählen',
    Expiration: 'Ablaufdatum',
  },
  at: {},
  uk: {
    paymentmethods: {
      heading: 'Методи оплати',
      add: 'Додати платіжний метод',
      description: 'Щоб оплатити підписку, ви можете додати додаткові платіжні методи тут.',
    },
    subscription: {
      heading: 'Підписки',
      description: 'Ваші підписки, рахунки та покупки будуть відображені тут.',
      noSubscriptions: 'Підписок не знайдено',
      per: 'за',
      since: 'з',
      interval: {
        day: 'день',
        week: 'тиждень',
        month: 'місяць',
        year: 'рік',
      },
    },

    Selected: 'Вибрано',
    Select: 'Вибрати',
    Expiration: 'Термін дії',
  },
  es: {
    paymentmethods: {
      heading: 'Métodos de pago',
      add: 'Agregar método de pago',
      description: 'Para pagar su suscripción, puede agregar métodos de pago adicionales aquí.',
    },
    subscription: {
      heading: 'Suscripciones',
      description: 'Sus suscripciones, facturas y compras aparecerán aquí.',
      noSubscriptions: 'No se encontraron suscripciones',
      per: 'por',
      since: 'desde',
      interval: {
        day: 'día',
        week: 'semana',
        month: 'mes',
        year: 'año',
      },
    },

    Selected: 'Seleccionado',
    Select: 'Seleccionar',
    Expiration: 'Expiración',
  },
}
